import React from 'react'

function Loading() {
  return (
    <div className='spinner-border text-success' role={'status'}>
        <span className="visually-hidden">Loading...</span>
    </div>
  )
}

export default Loading